export const getCurrentBranch = (state) => state.pageFooter.currentBranch;
